export default __webpack_public_path__ + "static/media/element_20.150b03f2.webp";